import { Directive } from '@angular/core';
import { AnimalInsuranceMetadata } from 'src/app/_types/lead.types';
import { getAnimalLabel } from 'src/app/enums/animal/animal.enum';
import { getCatTypeLabel } from 'src/app/enums/animal/cat-type.enum';

import { BaseMetadataComponent } from '../base-metadata.component';

@Directive()
export class AnimalMetadataComponentAbstract extends BaseMetadataComponent<AnimalInsuranceMetadata> {
  getAnimalType = getAnimalLabel;

  getCatType = getCatTypeLabel;
}
